import { z } from "zod";
import { BaseFilterInputSchema } from "../BaseFilterInput";

export const GetMyReportsInputSchema = BaseFilterInputSchema.extend({
    isAdmin: z.boolean().nullable().default(null),
    userName: z.string().nullable().default(null),
    partnerId: z.string().nullable().default(null),
});

export type GetMyReportsInput = z.infer<typeof GetMyReportsInputSchema>;